import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FooterComponent } from '../../components/footer.component/footer.component';
import { NavComponent } from '../../components/nav.component/nav.component';
import { AuthService } from '../../services/auth.service';

type ResetPasswordStatus = 'form' | 'submitting' | 'success' | 'error' | 'no-token';

@Component({
  selector: 'app-reset-password',
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    NavComponent,
    FooterComponent
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnInit {
  status: ResetPasswordStatus = 'form';
  errorMessage = '';
  token: string | null = null;
  password = '';
  confirmPassword = '';
  hidePassword = true;
  hideConfirmPassword = true;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');

    if (!this.token) {
      this.status = 'no-token';
    }
  }

  validatePassword(): boolean {
    if (!this.password || this.password.length < 8) {
      this.errorMessage = 'Password must be at least 8 characters long';
      return false;
    }

    if (!/[A-Z]/.test(this.password)) {
      this.errorMessage = 'Password must contain at least one uppercase letter';
      return false;
    }

    if (!/[a-z]/.test(this.password)) {
      this.errorMessage = 'Password must contain at least one lowercase letter';
      return false;
    }

    if (!/[0-9]/.test(this.password)) {
      this.errorMessage = 'Password must contain at least one number';
      return false;
    }

    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password)) {
      this.errorMessage = 'Password must contain at least one special character';
      return false;
    }

    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      return false;
    }

    return true;
  }

  resetPassword(): void {
    if (!this.validatePassword()) {
      return;
    }

    this.status = 'submitting';
    this.errorMessage = '';

    this.authService.resetPassword(this.token!, this.password)
      .subscribe({
        next: () => {
          this.status = 'success';
        },
        error: (err) => {
          this.status = 'error';
          this.errorMessage = err.error?.message || 'Failed to reset password. The link may be invalid or expired.';
        }
      });
  }
}
